import { type FC } from "react";

import { StepperItem, getStepStatus } from "./ModalStepper";

type TriageStep = 1 | 2 | 3 | 4;

const BASE_STEPS: { stepNumber: number; label: string; status: TriageStep }[] = [
  { stepNumber: 1, label: "Account setup", status: 1 },
  { stepNumber: 2, label: "Death certificate", status: 2 },
  { stepNumber: 3, label: "Legal authority", status: 3 },
];

interface TriageModalSidebarProps {
  activeStep?: TriageStep;
  showInvite?: boolean;
}

export const TriageModalSidebar: FC<TriageModalSidebarProps> = ({
  activeStep = 2,
  showInvite = false,
}) => {
  const steps = showInvite
    ? [...BASE_STEPS, { stepNumber: 4, label: "Invite", status: 4 as TriageStep }]
    : BASE_STEPS;

  return (
    <div className="hidden sm:flex h-full w-[250px] shrink-0 flex-col gap-4 border-r border-primary bg-white p-6">
      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold leading-[1.55] tracking-[-0.32px] text-primary">
          Confirm your authority
        </p>
      </div>
      <div className="flex flex-col gap-2">
        {steps.map(({ stepNumber, label, status }) => (
          <StepperItem
            key={stepNumber}
            stepNumber={stepNumber}
            label={label}
            status={getStepStatus(status, activeStep)}
          />
        ))}
      </div>
    </div>
  );
};
